/**
 * The call-to-action labels an author can put on a Meta single-image ad, as
 * Meta Ads Manager shows them in the Croatian locale.
 *
 * These strings ARE the stored value, not keys: the block persists the label
 * verbatim under `Text`, which is what the previews and the docx export read.
 * Rewording a row therefore orphans the CTA of every template that already
 * saved the old wording — add a row instead of editing one.
 */
export const META_CTA_TEXTS: readonly string[] = [
  'Rezerviraj odmah',
  'Kupi ulaznice',
  'Javite nam se',
  'Preuzmi',
  'Preuzmi ponudu',
  'Zatraži ponudu',
  'Prikaži raspored prikazivanja',
  'Saznajte više',
  'Poslušaj odmah',
  'Naruči odmah',
  'Pokreni igru',
];

/**
 * The Meta account the ad runs from. Same contract as {@link META_CTA_TEXTS}:
 * the label is stored verbatim under `AccountType`.
 */
export const META_ACCOUNT_TYPES: readonly string[] = ['Facebook', 'Instagram'];
